<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 

        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Información de Mancomunos
          </md-card-header>     

          <md-card-content>
            <p align="justify">
              Estimado cliente, es indispensable que la información brindada sea la correcta. Los documentos de suscripción y declaraciones juradas usarán estas respuestas. En caso de brindar información incompleta o incongruente, se congelará el proceso de suscripción y un promotor se contactará con usted para regularizar dicha información.
            </p>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>  
          </md-card-content> 
        </md-card>           

        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Datos Personales del Partícipe Titular
          </md-card-header>     

          <md-card-content>
            <p align="justify">
              Estimado cliente, es indispensable que la información brindada sea la correcta. Los documentos de suscripción y declaraciones juradas usarán estas respuestas. En caso de brindar información incompleta o incongruente, se congelará el proceso de suscripción y un promotor se contactará con usted para regularizar dicha información.
            </p>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>  
          </md-card-content> 
        </md-card>  

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('paterno')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido Paterno del Titular *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('paterno')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-model="form.paterno" v-on:keypress="isLetter($event, 0)" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.paterno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.paterno.alpha">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('materno')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido Materno del Titular *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('materno')">
                <md-input type="text" id="materno" name="materno" placeholder="Su respuesta" v-model="form.materno" v-on:keypress="isLetter($event,0)" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.materno.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.materno.alpha">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombres')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Nombre(s) del Titular *
          </md-card-header>
          <md-card-content>
            <div>            
              <md-field :class="getValidationClass('nombres')">
                <md-input type="text"   placeholder="Su respuesta" v-model="form.nombres" v-on:keypress="isLetter($event,0)" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombres.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.materno.alpha">Formato inválido</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                       

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Documento de identidad del Titular *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidad" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidad" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidad')">
                <span class="md-error" v-if="!$v.form.docIdentidad.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidad')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad del Titular *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidad')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidad" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidad.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidad.valDoc">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidad.minLength">Formato inválido</span> 
              </md-field>

            </div>
          </md-card-content> 
        </md-card>
   
        <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'" :hideBack="'true'"/>

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha, alpha1, alpha2, alpha3, valDoc } from '../variables'
//import { DataManager,Query,ODataV4Adaptor,Predicate } from "@syncfusion/ej2-data";
import { Query } from "@syncfusion/ej2-data";

import {
  required, minLength
} from 'vuelidate/lib/validators'


export default {
  mixins: [validationMixin],
  props:["pais"],
  name: 'Item1',
  data: () => ({
    form:{
    },
    query : new Query().select(['nacionalidad', 'idPais']).take(7),
    fields : { text: 'nacionalidad', value: 'nacionalidad' },
    allowFiltering: true,    
  }),
  mounted: function(){
    this.form = this.$store.state.item.item0
    
    if(this.form.fechaNac != null){
      this.form.fechaNac = new Date(this.form.fechaNac)
    }    
  },
  validations(){
    var validate = {
      form: {      
        paterno: {required, alpha},
        materno: {required, alpha},
        nombres: {required, alpha},
        docIdentidad: {required},
        nroIdentidad: {required, valDoc, minLength: minLength(3)}
      }        
    }
    return validate;
  },
  methods: {
    back(){
    },
    isLetter(e, i) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let validate;
      switch (i) {
        case 0:
          validate = alpha
          break;
        case 1:
          validate = alpha1
          break;          
        case 2:
          validate = alpha2
          break;
        case 3:
          validate = alpha3
          break;                    
      }

      if(validate(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },   
    ChangeOption(item){
      console.log(item)
    },
    ChangeOptionR(){
      this.$refs.pa.ej2Instances.value = null;
      this.$refs.pa.dataBind();
    },
    uploadFile(e){
      var data = new FormData();
      var that = this;
      var i = 0;
      Array.from(e).forEach(file => { 
        var name = ["File.", that.$route.params.id.toString(), ".", that.$options.name, ".", i, ".", file.name.split('.').pop()].join('')
        data.append('files', file, name);
        i++;
      }); 

      this.$store.dispatch("saveImgFormulario", data)
      .then(()=> {})
      .catch(()=> { });      
         
    },
    validateUser () {
      this.$v.$touch()
      var index = "01"
      if (!this.$v.$invalid) {

        this.$emit('setSaveForm', {id:"0", form: this.form, index: index});   
        
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },
    filtering: function(e) {
      var searchData = this.pais
      console.log(searchData)
      var query = new Query();
      //frame the query based on search string with filter type.
      query = (e.text != "") ? query.where("nacionalidad", "startswith", e.text, true) : query;
      //pass the filter data source, filter query to updateData method.
      console.log(query)
      //e.updateData(searchData, query);
    }      
     
  },
  computed: {

    otros0: function () {
      if(this.form.nacionalidad == "0"){
        return false;
      }
      return true;
    },
    otros1: function () {
      if(this.form.domicilioFuera == "0"){
        return false;
      }
      return true;
    },
    otros2: function () {
      if(this.form.residenciapermanente == "0"){
        return false;
      }
      return true;
    },            
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
